@if (show) {
<div class="button-confirmation-overlay" (click)="cancel()"></div>
}

<div class="button-confirmation-container">
  @if (show) {
  <button type="button" [ngClass]="btnClasses" class="btn btn-danger confirmation-button" (click)="confirm()">{{ message }}</button>
  }
  <ng-content></ng-content>
</div>
